<template>
    <div class="sa-free-page">
        <div class="sa-free-page-header">
            <b-card class="sa-card sa-card-border" header="Dettagli Piano" header-tag="header" footer-tag="footer" title="">
                <!--  <template #header>
                    <div style="display: flex">
                        <span style="flex: 1">Dettagli Piano</span>
                        <b-button size="sm" variant="outline-secondary outline-secondary-noborder pull-right" @click="onClickPianoEdit()">
                            <i class="bi bi-pencil"></i>
                        </b-button>
                    </div>
                </template> -->
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="3" xl="4">
                        <label class="sa-label-data">Struttura</label>
                        <span class="sa-data">{{ jsonData.denominazioneStruttura }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="3" xl="4">
                        <label class="sa-label-data">Presidio</label>
                        <span class="sa-data">{{ jsonData.denominazionePresidio }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="3" xl="4">
                        <label class="sa-label-data">Nome</label>
                        <span class="sa-data">{{ jsonData.nome }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Note</label>
                        <span class="sa-data">{{ jsonData.note }}</span>
                    </b-col>
                </b-row>
            </b-card>
        </div>
        <!-- <div class="sa-free-page-body">
            <b-card class="sa-card" header="Stanze" header-tag="header" footer-tag="footer" title="">
                <template #header>
                    <div style="display: flex">
                        <span style="flex: 1">Stanze</span>
                        <b-button size="sm" variant="outline-success outline-success-noborder pull-right" @click="onClickStanzeAdd()"> Nuovo<i class="bi bi-plus"></i> </b-button>
                    </div>
                </template>
                <ras-configurazione-posti-letto-stanze-list-component ref="cmpRsaConfigurazionePostiLettoStanzeListComponent" :idPiano="idPiano" :key="keyPiano"></ras-configurazione-posti-letto-stanze-list-component>
            </b-card>
        </div> -->

        <b-modal ref="mdlPianoEdit" size="lg" title="Modifica Dati Piano" @ok="onMdlPianoEditSave()">
            <ras-configurazione-posti-letto-piani-edit-component ref="cmpRasConfigurazionePostiLettoPianiEditComponent" :showModalLoading="showModalLoading"></ras-configurazione-posti-letto-piani-edit-component>
            <template #modal-footer="{ ok, cancel }">
                <b-button size="sm" variant="danger" @click="cancel()">Annulla</b-button>
                <b-button size="sm" variant="success" @click="ok()">Salva</b-button>
            </template>
        </b-modal>
        <ras-configurazione-posti-letto-stanze-edit-component ref="cmpConfigurazionePostiLettoStanzeEdit" :idPiano="idPiano" @onClose="loadData"> </ras-configurazione-posti-letto-stanze-edit-component>
    </div>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import RasConfigurazionePostiLettoStanzeEditComponent from "./RasConfigurazionePostiLettoStanzeEditComponent.vue";
import RasConfigurazionePostiLettoPianiEditComponent from "./RasConfigurazionePostiLettoPianiEditComponent.vue";
export default {
    mixins: [UtilityMixin],
    components: { RasConfigurazionePostiLettoStanzeEditComponent, RasConfigurazionePostiLettoPianiEditComponent },
    data() {
        return {
            id: null,
            strutturaOptions: [],
            pathResource: "/rsapostilettopiani",
            pathResourceStrutture: "/strutture",
            jsonData: { id: null, codiceStruttura: null, idPresidio: null, nome: null, note: null },
            showModalLoading: false,
            idPiano: null,
            keyPiano: 100,
        };
    },
    watch: {
        jsonData: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    mounted: function () {
        let me = this;
        me.id = this.$route.params.id;
        me.loadData();
    },
    methods: {
        loadDataStruttureSuccess(response) {
            let me = this;
            me.strutturaOptions = response.data.data;
            me.strutturaOptions.unshift({ codiceStruttura: null, denominazione: this.$i18n.t("clinic.lblSelectStructure") });
            me.loadData();
            me.$emit("afterLoadData");
        },
        loadDataStruttureError(response) {
            let me = this;
            me.$bvToast.toast("Errore durante il caricamento delle strutture", response, {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
            me.$emit("afterLoadData");
        },
        loadData() {
            let me = this;
            me.show;
            if (me.id === "-1") {
                me.$emit("afterLoadData");
            } else {
                me.loadDataResources(me.pathResource + "/" + me.id, null, me.loadDataSuccess, me.loadDataError);
                me.$emit("beforeLoadData");
            }
        },
        loadDataSuccess(response) {
            let me = this;
            me.$emit("afterLoadData");
            me.jsonData = response.data.data;
            me.idPiano = me.jsonData.id;
            me.keyPiano++;
        },
        loadDataError(response) {
            let me = this;
            me.$bvToast.toast("Errore durante il caricamento dei dati", response, {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
            me.$emit("afterLoadData");
        },

        onClickPianoEdit() {
            let me = this;
            me.$refs.mdlPianoEdit.show();
        },
        onMdlPianoEditSave() {
            let me = this;
            let jsonData = me.$refs.cmpRasConfigurazionePostiLettoPianiEditComponent.getJsonData();
            UtilityMixin.methods.saveResource(me.pathResource, jsonData, me.saveSucessResponse, me.saveErrorResponse);
        },
        saveSucessResponse() {
            let me = this;
            me.loadData();
        },
        saveErrorResponse(response) {
            if (response.response.status === 400) {
                this.$emit("errorRestCall", response);
            } else {
                this.$bvToast.toast("Errore nel salvarei dati del Piano: " + response.message, {
                    title: "",
                    variant: "danger",
                    solid: true,
                });
            }
        },
    },
};
</script>

<style></style>
